import { render, staticRenderFns } from "./GoodsOfferDetails.vue?vue&type=template&id=8b5f2a88&"
import script from "./GoodsOfferDetails.vue?vue&type=script&lang=js&"
export * from "./GoodsOfferDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports